<template>
    <BasicDialog :duration="duration / 1000" ref="basicDialogRef" v-if="show">
        <template v-slot:header v-if="!!title">
            <div class="information-header">
                {{ title }}
            </div>
        </template>

        <template>
            <div :class="['information-box', { 'no-header': !title, 'text-left': typeof message !== 'string' }]">
                <template v-if="typeof message === 'string'">
                    {{ message }}
                </template>

                <template v-else>
                    <div v-for="(item, index) in message" :key="index">{{ item }}</div>
                </template>
            </div>
        </template>

        <template v-slot:footer v-if="type > 0">
            <div class="information-footer">
                <template v-if="type === 1">
                    <div class="button-item" @click="closeDialog">关闭</div>
                </template>

                <template v-if="[2, 3, 4].includes(type)">
                    <div class="button-item" @click="closeDialog">取消</div>
                    <div class="button-item confirm" @click="confirm">确定</div>
                </template>

                <template v-if="type === 5">
                    <div class="button-item" @click="closeDialog">我知道了</div>
                </template>
            </div>
        </template>
    </BasicDialog>
</template>

<script>
import BasicDialog from "./BasicDialog.vue";

export default {
    name: "InformationDialog",
    components: {
        BasicDialog,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            default: "",
        },
        message: {
            type: [String, Array],
            required: true,
        },
        duration: {
            type: Number,
            default: 150,
        },
        type: {
            type: Number,
            default: 1, // 1-关闭，2-省市，3-区县，4-付款，5-我知道了
        },
    },
    data() {
        return {};
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.currentTime = this.time;
            }
        },
    },
    methods: {
        closeDialog() {
            return new Promise((reslove, reject) => {
                if (this.$refs.basicDialogRef) {
                    this.$refs.basicDialogRef.hiddenDialog();
                }

                setTimeout(() => {
                    this.$emit("close");

                    reslove(true);
                }, this.duration);
            });
        },

        confirm() {
            this.closeDialog().then((res) => {
                this.$emit("confirm", this.type);
            });
        },
    },
};
</script>

<style scoped lang="scss">
* {
    font-family: PingFang-SC;
    color: #323233;
}

::v-deep .dialog-box_header {
    .information-header {
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        padding-top: 16px;
    }
}

::v-deep .dialog-box_content {
    .information-box {
        font-size: 13px;
        // text-align: center;
        text-align: left;
        padding: 12px 16px;
        padding-bottom: 20px;
        border-bottom: 1px solid #f1f1f1;

        &.text-left {
            text-align: left;
        }

        &.no-header {
            padding-top: 30px;
        }
    }
}

::v-deep .dialog-box_footer {
    .information-footer {
        // padding-block: 16px;
        display: flex;
        align-items: center;
        justify-content: center;

        .button-item {
            flex: 1;
            padding: 10px 16px;
            text-align: center;
            // font-weight: 600;
            font-size: 14px;
            cursor: pointer;

            &:not(.button-item:first-of-type) {
                border-left: 1px solid #f1f1f1;
            }

            &.confirm {
                color: #1989fa;
            }
        }
    }
}
</style>
